import { createComponent } from '@mtfe/sweet';
import { Tabs, componentUtils } from '@mtfe/sweet-components';
import { dom, eventBus, common } from '@mtfe/sweet-utils';

import style from './style.less';
import tpl from './dom.html';
import store from '../../store/index';
import InnerPoi from '../common/InnerPoi/script';

const { getOnClickEventName } = componentUtils;
const { createUniqueId, throttle } = common;

class PoiListWithTabs {
    constructor(props = {}) {
        const { targetStore, renderFunc, isSticky } = props;
        this.tabNavID = createUniqueId();
        this.component = this.createDom(targetStore, renderFunc, isSticky);
        this.readyEventName = `${this.tabNavID}PoiListWithTabsReady`;
        this.registerReady(targetStore, isSticky);
    }

    createDom(targetStore, renderFunc, isSticky) {
        const { tabsInfo } = targetStore;
        const defaultActiveTabKey = tabsInfo[0].recallBizId;

        const tabs = Tabs({
            tabInfo: tabsInfo.map((item) => {
                const { recallBizId } = item;
                const resItem = { ...item, key: recallBizId, label: item.text };
                const poiData = store[recallBizId].poiData;
                resItem.innerComponent = InnerPoi({
                    poiData,
                    renderFunc,
                });
                return resItem;
            }),
            defaultActiveTabKey,
            onTabBarClick: (key) => {
                const eventName = getOnClickEventName(key);
                eventBus.$emit(eventName);
            },
            theme: 'crazy',
            isSticky,
            stickMargin: 180,
            tabNavID: this.tabNavID,
        });
        const data = {
            tabs,
        };
        const events = {};
        const component = createComponent(tpl, { data, style }, events);
        return component;
    }

    getComponent() {
        return this.component;
    }

    registerReady(targetStore, isSticky) {
        const { tabsInfo } = targetStore;
        eventBus.$on(this.readyEventName, () => {
            if (isSticky) {
                document.addEventListener(
                    'scroll',
                    throttle(() => {
                        this.onSticky();
                    }, 200),
                );
            }
            eventBus.$emit(getOnClickEventName(tabsInfo[0].recallBizId));
        });
    }

    ready() {
        eventBus.$emit(this.readyEventName);
    }

    onSticky() {
        setTimeout(() => {
            const tabNavDom = dom.$id(this.tabNavID);
            const { top } = tabNavDom.getBoundingClientRect();
            if (Math.abs(top) <= 1) {
                return;
            }
            const currentVw = window.screen.width / 100;
            const maxTop = currentVw * 24;
            if (top <= maxTop || Math.abs(top - maxTop) <= 1) {
                tabNavDom.classList.add(style.tabsNavCeiling);
            } else {
                tabNavDom.classList.remove(style.tabsNavCeiling);
            }
        });
    }
}

export default PoiListWithTabs;
